export default __webpack_public_path__ + "static/media/sentiment-positive.727faaab.svg";